import { Phone, Mail, MapPin, type LucideIcon } from "lucide-react";
import { CONTACT } from "@/constants/site";
import type { ContactItem } from "@/types/models";

export const contactItems: ContactItem[] = [
  {
    iconName: "Phone",
    label: "Telefone",
    value: CONTACT.phoneDisplay,
    href: `tel:${CONTACT.phone}`,
  },
  {
    iconName: "Mail",
    label: "Email",
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
  },
  {
    iconName: "MapPin",
    label: "Morada",
    value: CONTACT.address.display,
    href: "https://maps.google.com/?q=Travessa+do+Ferro+7+Viseu",
    isExternal: true,
  },
];

export const contactIconMap: Record<string, LucideIcon> = {
  Phone,
  Mail,
  MapPin,
};
